/* eslint-disable import/prefer-default-export */
import { GET_USER_ONBOARDING, GET_USER_DETAILS } from '../../types/Types';

export const onBoarding = (data) => ({
  type: GET_USER_ONBOARDING,
  data,
});

export const saveDetails = (data) => ({
  type: GET_USER_DETAILS,
  data,
});
